<template>
  <div>
    <div>
      <l-editor
        disabled
        :isUploadImg="false"
        v-if="data.type == 'texteditor'"
        :height="data.height"
        v-model="data.default"
        :placeholder="data.placeholder"
      >
      </l-editor>

      <component
        style="width: 200px"
        size="mini"
        v-else
        :is="getComponent(data.type)"
        v-model="internalValue"
        v-bind="$deepClone(data)"
        :placeholder="data.placeholder"
        :options="myOptions"
        @input="handleInput"
        :isNotUpLoad="true"
        :showFileList="uploadFileList"
      >
        <span v-if="data.html" v-html="data.html" />
        <template v-if="['input'].includes(data.type) && data.prepend" #prepend>
          {{ data.prepend }}
        </template>
        <template v-if="['input'].includes(data.type) && data.append" #append>
          {{ data.append }}
        </template>
      </component>
    </div>
  </div>
</template>
<script>
import mixin from "./mixin";
export default {
  name: "drag-form-item",
  mixins: [mixin()],
  inject: ["formDesign", "formData"],
  props: {
    query: {},
    value: {},
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  computed: {
    uploadFileList() {
      if (this.data.subfield) {
        return "popover";
      } else {
        return true;
      }
    },
  },
  data() {
    return {
      internalValue: this.value,
    };
  },
  beforeDestroy() {},
  mounted() {},
  methods: {
    handleInput(value) {
      this.$emit("input", value);
    },
    log(data) {
      console.log(data);
    },
    toValueType(type, value) {
      console.log(type);

      if (!this.$validatenull(value) && !this.$validatenull(type)) {
        switch (type) {
          case "boolean":
            return value == "true";
          case "string":
            return value;
          case "number":
            return Number(value);
          default:
            return value;
        }
      }
    },
  },
  watch: {
    value(newVal) {
      this.internalValue = newVal;
    },
  },
};
</script>
